import { Component, OnDestroy, OnInit } from '@angular/core';
import { MainDataService } from './services/main-data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppDocDynamicPageService } from './services/app-doc-dynamic-page.service';
import { DocDynamicPageService } from './pages/project-page/doc-dynamic-page/doc-dynamic-page.service';
import { NbIconLibraries } from '@nebular/theme';
import { ToastComponent } from './components/toast/toast.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ToastComponent],
  providers: [
    {
      provide: DocDynamicPageService,
      useClass: AppDocDynamicPageService,
    },
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();

  constructor(
    private mainDataService: MainDataService,
    private title: Title,
    private iconLibraries: NbIconLibraries,
  ) {
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fab' });
    this.iconLibraries.registerFontPack('material-icons', {
      ligature: true,
      packClass: 'material-symbols-rounded',
    });
  }

  ngOnInit(): void {
    this.mainDataService.projectSettings$.pipe(takeUntil(this.destroy$)).subscribe((settings) => {
      this.title.setTitle(settings.title);
      if (settings.favicon) {
        const favIcon: HTMLLinkElement = document.querySelector('#favIcon');
        favIcon.href = settings.favicon;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
